import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { ASSETS, OPPORTUNITY, FINAL_CTA } from "../../data/content";
import Reveal from "./Reveal";

export default function Opportunity() {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section
      id="opportunity"
      ref={ref}
      data-testid="opportunity-section"
      className="relative bg-[#050B14] py-24 md:py-40 overflow-hidden border-t border-white/5"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 md:gap-12 items-center">
          <div className="col-span-12 lg:col-span-6">
            <Reveal>
              <div className="flex items-center gap-4 mb-8">
                <div className="h-px w-12 bg-[#E5D3B3]" />
                <span className="overline">{OPPORTUNITY.overline}</span>
              </div>
            </Reveal>
            <Reveal delay={0.1}>
              <h2
                data-testid="opportunity-headline"
                className="font-serif-display text-white text-[clamp(2.5rem,5.5vw,5rem)] leading-[1.02] font-light tracking-[-0.02em] whitespace-pre-line"
              >
                {OPPORTUNITY.title}
              </h2>
            </Reveal>
            <Reveal delay={0.25}>
              <p className="mt-10 text-[#D4C9A8] text-base md:text-lg font-light leading-relaxed max-w-xl">
                {OPPORTUNITY.body}
              </p>
            </Reveal>
            <Reveal delay={0.4}>
              <a
                href={FINAL_CTA.dossierUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="opportunity-cta"
                className="btn-primary mt-12"
              >
                {OPPORTUNITY.cta}
                <span aria-hidden="true">→</span>
              </a>
            </Reveal>
          </div>

          <div className="col-span-12 lg:col-span-6 lg:pl-12">
            <div className="relative aspect-[4/5] overflow-hidden">
              <motion.img
                style={{ y }}
                src={ASSETS.yacht.bowCityscape}
                alt="MARIE-JOSEPH at sunset — ready for her next chapter"
                loading="lazy"
                className="absolute inset-0 w-full h-[115%] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050B14]/50 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                <div className="overline text-white/80">Available now</div>
                <div className="overline text-[10px] text-white/60">08 / 09</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
